import { identity } from "lodash";
import { Plus, Minus, RotateCcw } from "lucide-react";
import {
  TransformComponent,
  TransformWrapper,
  useControls,
} from "react-zoom-pan-pinch";
import { Dialog, DialogContent } from "../ui/dialog";
import { Button } from "../ui/button";

export const ImageModal = ({ open = false, onClose = identity, url = "" }) => {
  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
      <div className="absolute bottom-4 right-4 flex gap-1 z-50">
        <div className="bg-black/90 rounded-lg flex shadow-lg p-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => zoomIn()}
            className="text-white hover:text-white hover:bg-white/20 h-10 w-10"
          >
            <Plus className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => zoomOut()}
            className="text-white hover:text-white hover:bg-white/20 h-10 w-10"
          >
            <Minus className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => resetTransform()}
            className="text-white hover:text-white hover:bg-white/20 h-10 w-10"
          >
            <RotateCcw className="h-4 w-4" />
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-[90vw] sm:max-w-3xl lg:max-w-4xl w-full p-0 bg-white [&>button]:!hidden">
        {/* Header with Close Button */}
        <div className="flex items-center justify-end px-4 py-3 border-b border-gray-200">
          <Button
            onClick={onClose}
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full hover:bg-gray-100 text-gray-500 hover:text-gray-700"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </Button>
        </div>

        {/* Image Container */}
        <div className="relative w-full h-[50vh] sm:h-[60vh] lg:h-[70vh] bg-white p-2">
          <TransformWrapper
            defaultScale={1}
            defaultPositionX={0}
            defaultPositionY={0}
            wheel={{ disabled: false }}
            pinch={{ disabled: false }}
            panning={{ velocityDisabled: false }}
            pinchSensitivity={1.5}
            doubleClick={{ disabled: false }}
            smooth={true}
            minScale={0.5}
            maxScale={4}
          >
            <TransformComponent
              wrapperClass="!w-full !h-full"
              contentClass="!w-full !h-full flex items-center justify-center"
            >
              <img
                src={url}
                alt="Property"
                className="w-full h-full object-contain"
              />
            </TransformComponent>
            <Controls />
          </TransformWrapper>
        </div>
      </DialogContent>
    </Dialog>
  );
};
